import type { ReactNode } from "react";

import { Card } from "@prophero-ds/cx-react";

import { cn } from "@/lib/utils";

interface ResponsiveScreenLayoutProps {
  children: ReactNode;
  button?: ReactNode;
  /** CX Card density. `large` is 24px × 16px; `small` is 12px. */
  cardSize?: "small" | "medium" | "large";
  maxWidth?: 390 | 397 | 408 | 416 | 420 | 436;
}

/**
 * Card container for Auth0 custom screen content.
 *
 * Submit actions stay in normal document flow. Viewport chrome (language
 * selector, logo, product image) lives in AuthSplitLayout.
 *
 * @param children - Main content to display
 * @param button - Optional button/action element (e.g., submit button, navigation link)
 * @param cardSize - CX Card padding density (default: small, 12px)
 * @param maxWidth - Maximum width of the card (default: 390)
 */
function ResponsiveScreenLayout({
  children,
  button,
  cardSize = "small",
  maxWidth = 390,
}: ResponsiveScreenLayoutProps) {
  const maxWidthClass = {
    390: "max-w-[390px]",
    397: "max-w-[397px]",
    408: "max-w-[408px]",
    416: "max-w-[416px]",
    420: "max-w-[420px]",
    436: "max-w-[436px]",
  }[maxWidth];

  return (
    <div className="flex w-full justify-center px-4">
      <Card
        size={cardSize}
        className={cn("flex w-full flex-col items-center gap-6", maxWidthClass)}
        style={{ overflow: "visible" }}
      >
        {children}
        {button}
      </Card>
    </div>
  );
}

export default ResponsiveScreenLayout;
